import { getInstanceByDom, getInstanceById } from "echarts";

export default {
    // insurance 列表页 list 
    getInsuranceShow: "/accountPayable/insurance/showInsurance",
    // 获取Agent type数据
    getAgentType:"/accountPayable/insurance/vendorType",
    // 根据propId 获取相关数据
    getPropDetails:"/accountPayable/insurance/propDetails",
    // 上传文件
    getInsuranceFile:"/accountPayable/insurance/uploadFile",
    // 获取insurance type 数据
    getInsuranceType:"/accountPayable/insurance/insuranceType",
    // /新增数据
    getInsuranceAdd:"/accountPayable/insurance/addInsurance",
    // 根据ID查询数据
    getInsuranceById:"/accountPayable/insurance/insuranceById",
    // enter 提交数据修改
    getInstanceEnter:"/accountPayable/insurance/enterPayment",
    // uploadPolicy 上传附件
    getInstanceUpload:"/accountPayable/insurance/uploadPolicy",
    // dele 删除
    getInstanceDel:"/accountPayable/insurance/delInsurance",
    // dele 删除二次确认
    getInstanceDelConfirm:"/accountPayable/insurance/delInsurance",
    // 获取GlAcct
    getInstanceByGlAcct:"/accountPayable/insurance/insuranceGlAcct",
    //  账单文件上传
    getInstanceByUpload:"/accountPayable/insurance/uploadPayment",
    // Excel 附件上传
    getInstanceByExcl:"/accountPayable/insurance/uploadBuilding",
    // Excel 附件校验Number是否重复
    getInstanceCheckByExcl:"/accountPayable/insurance/checkUploadBuilding",
    //  updateInsuranceByBuilding 修改
    getUpdateInsuranceByBuilding :"/accountPayable/insurance/updateInsuranceByBuilding",
    // 删除编辑表单里的文件
    getDelInsuranceFile:"/accountPayable/insurance/delInsuranceFile",
    // 改变Status状态
    getInsuranceOpenStatus:"/accountPayable/insurance/updateOpenStatus",
    // Insurance 修改remark
    getUpdateLiabilityRemark:"/accountPayable/insurance/updateLiabilityRemark",

    // insurance summary 
    getInsuranceSummary:"/accountPayable/insurance/showInsuranceProject",
    // insuranceSummary 新增
    getInsuranceSummaryAdd:"/accountPayable/insurance/addInsuranceProject",
    // insuranceSummary 修改
    getInsuranceSummaryUpdate:"/accountPayable/insurance/updateInsuranceProject",
     // insuranceSummary 删除
    getInsuranceSummaryDel:"/accountPayable/insurance/delInsuranceProject",
    // insurance by prop 列表数据
    getInsuranceByPropShow:"/accountPayable/insurance/showPropInsurance",
    // insurance by prop 列表新增
     getInsuranceByPropAdd:"/accountPayable/insurance/addPropInsurance",
    //  insurance prop 反显详情
    getInsuranceByPropAmount:'/accountPayable/insurance/propByInsuranceAmount',
    // insurance  反显 推送账单记录
    getInsurancePaymentById:"/accountPayable/insurance/insurancePaymentById",
    // insurance 账单文件上传
    getInsurancePaymentFile:"/accountPayable/insurance/uploadPayment",
    // insurance by GL
    getInsuranceByGlAcct:"/accountPayable/insurance/insuranceGlAcctOption",
};